<table class="table table-bordered" id="table" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ expenseI18n.nameI18n }}</th>
      <th>{{ expenseI18n.dateI18n }}</th>
      <th>{{ expenseI18n.amountI18n }}</th>
      <th></th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>{{ expenseI18n.nameI18n }}</th>
      <th>{{ expenseI18n.dateI18n }}</th>
      <th>{{ expenseI18n.amountI18n }}</th>
      <th></th>
    </tr>
  </tfoot>
  <tbody *ngIf="expenses.length > 0">
    <tr *ngFor="let c of expenses">
      <td>{{ c.name }}</td>
      <td>{{ c.date }}</td>
      <td>{{ c.amount }}</td>
      <td>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          (click)="delete(c.id)"
        >
          <i class="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
